<template>
  <div>
    <v-list
      color="grey lighten-3"
      dense
      dark
      v-if="Object.values(Pedido.items).length !== 0"
    >
      <v-list-item three-line class="mt-n3">
        <v-list-item-content>
          <v-list-item-title
            v-if="Pedido.data.Descuento !== 0"
            class="primary--text d-flex justify-space-between"
          >
            <span>Sub Total</span>
            <span class="text-subtitle-2 font-weight-bold">
              {{ simboloMoneda[tipoMoneda] }}
              {{ Pedido.data.MontoBruto[tipoMoneda] | numeral("0,0.00") }}
            </span>
          </v-list-item-title>

          <v-list-item-subtitle
            v-if="Pedido.data.Descuento !== 0"
            class="mt-1 primary--text d-flex justify-space-between"
          >
            <span>
              Descuento {{ Pedido.data.Descuento | numeral("0,0.00") }}%
            </span>
            <span class="text-subtitle-2 font-weight-bold">
              {{ simboloMoneda[tipoMoneda] }}
              {{ Pedido.data.MontoDes[tipoMoneda] | numeral("0,0.00") }}
            </span>
          </v-list-item-subtitle>
          <v-list-item-subtitle
            class="mt-1 primary--text d-flex justify-space-between"
          >
            <span> Total Neto </span>
            <span class="text-subtitle-2 font-weight-bold">
              {{ simboloMoneda[tipoMoneda] }}
              {{ Pedido.data.MontoNeto[tipoMoneda] | numeral("0,0.00") }}
            </span>
          </v-list-item-subtitle>
          <v-list-item-subtitle
            v-if="Pedido.data.MontoIva[tipoMoneda] !== 0"
            class="mt-1 primary--text d-flex justify-space-between"
          >
            <span> Total IVA</span>
            <span class="text-subtitle-2 font-weight-bold">
              {{ simboloMoneda[tipoMoneda] }}
              {{ Pedido.data.MontoIva[tipoMoneda] | numeral("0,0.00") }}
            </span>
          </v-list-item-subtitle>
          <v-list-item-subtitle
            class="mt-1 primary--text d-flex justify-space-between"
          >
            <span class="font-weight-bold"> TOTAL PEDIDO </span>
            <span class="text-subtitle-1 font-weight-bold">
              {{ simboloMoneda[tipoMoneda] }}
              {{ Pedido.data.MontoTotal[tipoMoneda] | numeral("0,0.00") }}
            </span>
          </v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
    </v-list>
    
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  computed: {
    ...mapState([
      "dataUser",
      "Cliente",
      "Pedido",
      "tipoMoneda",
      "simboloMoneda",
      "domoapi2_img",
    ]),
  },
};
</script>

<style></style>
